<form class="register" [formGroup]="formGroup!" data-testid="forgot-pw-container">
  <app-modal-option-panel>
    <p>{{ languageService.languageJSON.AccountDialog_ForgotPassword_Description }}:</p>
    <div class="input-el">
      <input name="email" required placeholder="Email" formControlName="recoveryEmail" type="email" data-testid="forgot-pw-email-input">
      @if (recoveryEmail.invalid && recoveryEmail.touched) {
      <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_Email_Invalid }}</h6>
      }
      @if (existingEmailMsg) {
      <h6 class="invalid">{{ existingEmailMsg }}</h6>
      }
    </div>
    @if (emailSent) {
    <p>{{ languageService.languageJSON.AccountDialog_EmailSent }}</p>
    }
  </app-modal-option-panel>
</form>